module.exports = __webpack_public_path__ + "img/Hmm_revised.e522078f.svg";